import { useMemo } from 'react';

import { getYCurrentLossHelper } from 'features/Croptimizer/utils/calcHelperBoard';
import { BoardMineralization, BoardStatus } from 'features/Croptimizer/types';

interface Props {
  boardStatusValues: BoardStatus | null;
  mineralizationValues: BoardMineralization | null;
}

const useCurrentLoss = ({ boardStatusValues, mineralizationValues }: Props) => {
  const getY1CurrentLoss = useMemo(() => {
    if (boardStatusValues && mineralizationValues) {
      if (boardStatusValues?.currentPh < boardStatusValues?.targetPh) {
        return getYCurrentLossHelper(
          boardStatusValues?.currentPh,
          mineralizationValues?.annualDecrease,
        );
      } else {
        return getYCurrentLossHelper(
          boardStatusValues?.targetPh,
          mineralizationValues?.annualDecrease,
        );
      }
    }

    return '';
  }, [boardStatusValues, mineralizationValues]);

  const getY2CurrentLoss = useMemo(() => {
    if (getY1CurrentLoss && mineralizationValues && boardStatusValues) {
      return getYCurrentLossHelper(
        getY1CurrentLoss,
        mineralizationValues?.annualDecrease,
      );
    }

    return '';
  }, [boardStatusValues, mineralizationValues, getY1CurrentLoss]);

  const getY3CurrentLoss = useMemo(() => {
    if (getY2CurrentLoss && mineralizationValues && boardStatusValues) {
      return getYCurrentLossHelper(
        getY2CurrentLoss,
        mineralizationValues?.annualDecrease,
      );
    }

    return '';
  }, [boardStatusValues, mineralizationValues, getY2CurrentLoss]);

  const getY4CurrentLoss = useMemo(() => {
    if (getY3CurrentLoss && mineralizationValues && boardStatusValues) {
      return getYCurrentLossHelper(
        getY3CurrentLoss,
        mineralizationValues?.annualDecrease,
      );
    }

    return '';
  }, [boardStatusValues, mineralizationValues, getY3CurrentLoss]);

  const getY5CurrentLoss = useMemo(() => {
    if (getY4CurrentLoss && mineralizationValues && boardStatusValues) {
      return getYCurrentLossHelper(
        getY4CurrentLoss,
        mineralizationValues?.annualDecrease,
      );
    }

    return '';
  }, [boardStatusValues, mineralizationValues, getY4CurrentLoss]);

  return {
    getY1CurrentLoss,
    getY2CurrentLoss,
    getY3CurrentLoss,
    getY4CurrentLoss,
    getY5CurrentLoss,
  };
};

export default useCurrentLoss;
